import { ALLOWED_DATA_SOURCE_SERVICES } from '@kfolks/types'
import { z } from 'zod'

/**
 * Endpoint pattern: starts with `/`, contains no `:` (rules out schemes and
 * port-looking URLs), and no whitespace. This is the SSRF defense at the
 * schema layer; runtime adapter-routing is the second line of defense.
 */
const relativeEndpointRegex = /^\/[^:\s]*$/

export const dataSourceCreateSchema = z.object({
	sourceKey: z.string().min(1).max(100),
	name: z.string().min(1).max(255),
	description: z.string().optional(),
	serviceName: z.enum(ALLOWED_DATA_SOURCE_SERVICES),
	endpoint: z.string().regex(relativeEndpointRegex, 'Must be a relative path starting with / (no scheme, no colons)'),
	labelField: z.string().default('name'),
	valueField: z.string().default('id'),
	filters: z.record(z.string(), z.unknown()).optional(),
	cacheTtlSeconds: z.number().int().min(0).optional(),
})

export const dataSourceUpdateSchema = dataSourceCreateSchema.partial()

export type DataSourceCreateInput = z.infer<typeof dataSourceCreateSchema>
export type DataSourceUpdateInput = z.infer<typeof dataSourceUpdateSchema>
